<template lang="pug">
	
	.bills-overlay
		img(src="assets/images/trump-bill.png" v-for="bill in amount").bill

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scrollable from '~abstracts/scrollable'
	import Globals from '~utils/Globals'


  	@Component({
		name: 'BillsOverlay',
		components: { },
		data: function () {
			return {
				amount: 60
			}
		}
	})

	class BillsOverlay extends Scrollable {

		mounted () {
			super.mounted()

			this._dom()
		}

		init () {
			super.init()

		}

		beforeDestroy () {
			super.beforeDestroy()
		}

		_bind () {
			super._bind()
		}

		_dom () {
			this.$bills = this.$el.querySelectorAll('.bill')
		}

		_intervals () {
			
			const gap = window.innerWidth / this.amount
			const range = Globals.responsiveWidth(350)

			this.tlScroll = new TimelineMax({paused: true})

			for(let i = 0; i < this.amount; i++) {

				const min = gap*i - range
				const max = gap*i + range/2

				let b = this.$bills[i]
				const posX = Math.random()*(max - min) + min
				const rotZ = Math.random()*(40 + 40) - 40
				const delay = Math.random()*(.5)
				const rHeight = Math.random() * (Globals.responsiveHeight(600) + Globals.responsiveHeight(400)) - Globals.responsiveHeight(400)

				TweenMax.set(b,{left: posX, rotationZ: rotZ,width:Globals.responsiveWidth(450), scale:1 })

				this.tlScroll.fromTo(b,1,{y:Globals.responsiveHeight(450)},{y:-window.innerHeight - rHeight - Globals.responsiveHeight(600), delay:delay, ease: Power1.easeOut},0)

			}

		}

		play (ratio) {
			this.tlScroll.progress(ratio)
		}

		test(duration,) {

		}

		_points () {

		} 

		_resize () {
			super._resize()

			this._intervals()
			this._points()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default BillsOverlay

</script>


<style lang="stylus">
	
	@import '../../theme/utils'
	@import '../../theme/variables'
	
	.bills-overlay
		width 100%
		position absolute
		top 0
		left 0
		height 100vh
		width 100vw
		overflow hidden
		pointer-events none
		
		.bill
			position absolute
			bottom 0px
			width 400px

</style>


// WEBPACK FOOTER //
// bills-overlay.vue?a30246e4